import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { AuthService } from "./auth.service";
import { CustomerService } from "./customer.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor
{

  constructor(private authService: AuthService, private customerService: CustomerService) { }

  // example here: https://blog.angular-university.io/angular-jwt-authentication/
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>>
  {
    const idToken = sessionStorage.getItem("access_token");
    let request = req;

    if (idToken)
    {
      request = req.clone({
        headers: req.headers.set("Authorization", "Bearer " + idToken)
      });
    }

    // example here: https://stackblitz.com/edit/angular-8-registration-login-example?file=app%2F_helpers%2Ferror.interceptor.ts
    return next.handle(request)
      .pipe(catchError(err =>
      {
        if (err.status === 401)
        {
          // TODO: may want to check that it's a rcc service and not a external service before logging the user out.
          // auto logout if 401 response returned from the api
          this.authService.logout();
          this.customerService.clearCustomerData();
        }

        return throwError(err);
      }));
  }

}
